import { render } from "./SlimlineRegSizeForm.vue?vue&type=template&id=51b8d8b7&scoped=true"
import script from "./SlimlineRegSizeForm.vue?vue&type=script&lang=js"
export * from "./SlimlineRegSizeForm.vue?vue&type=script&lang=js"

import "./SlimlineRegSizeForm.vue?vue&type=style&index=0&id=51b8d8b7&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b8d8b7"]])

export default __exports__